import Vue from 'vue';
import * as api from '../api/api.js'


export const formatDate = Vue.filter('formatDate', now => {
	  var d = new Date( now );
	  var year = d.getFullYear();
	  var month = d.getMonth() + 1;
	  var date = d.getDate();
	  var hour = d.getHours();
	  var minute = d.getMinutes();
	  var second = d.getSeconds();
	 return year + '-' + month + '-' + date + " " + hour + ":" + minute + ":" + second;
})




// WEBPACK FOOTER //
// ./src/filter/filter.js